import { jsx as _jsx } from "react/jsx-runtime";
import { toast } from "react-toastify";
import ErrorToastContent from "./ErrorToastContent";
export function stliteStyledPromiseToast(promise, messages) {
    const errorMessage = messages.error;
    return toast.promise(promise, {
        pending: messages.pending,
        success: messages.success,
        error: typeof errorMessage === "string"
            ? {
                render({ data }) {
                    return data ? (_jsx(ErrorToastContent, { message: errorMessage, error: data })) : (errorMessage);
                },
                autoClose: false,
                closeOnClick: false,
            }
            : errorMessage,
    }, {
        hideProgressBar: true,
        position: "bottom-right",
    });
}
//# sourceMappingURL=promise.js.map